export default "__VITE_ASSET__Hwmr6vJy__"